import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { waLink } from "@/lib/whatsapp";

const LINKS = [
    { label: "Serviços", href: "#servicos", testid: "nav-link-servicos" },
    { label: "Cardápio Digital", href: "#cardapio", testid: "nav-link-cardapio" },
    { label: "Demo ao Vivo", href: "/demo", testid: "nav-link-demo" },
    { label: "Sobre", href: "#sobre", testid: "nav-link-sobre" },
    { label: "Contato", href: "#contato", testid: "nav-link-contato" },
];

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="main-navbar"
            className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
                scrolled
                    ? "border-b border-white/[0.06] bg-[#07090E]/80 backdrop-blur-xl"
                    : "border-b border-transparent bg-transparent"
            }`}
        >
            <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-5 sm:px-8">
                <a href="#top" aria-label="Strondex Tech — início">
                    <Logo compact={open} />
                </a>

                <nav className="hidden items-center gap-8 lg:flex" aria-label="Navegação principal">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testid}
                            className="text-sm font-medium text-slate-400 transition-colors duration-300 hover:text-cyan-300"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href={waLink("general")}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-whatsapp-button"
                        className="hidden items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-bold text-[#052e12] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#2ce06f] hover:shadow-[0_8px_28px_rgba(37,211,102,0.35)] sm:inline-flex"
                    >
                        <MessageCircle size={17} strokeWidth={2.5} />
                        Falar no WhatsApp
                    </a>
                    <button
                        data-testid="nav-mobile-toggle"
                        onClick={() => setOpen(!open)}
                        className="rounded-lg border border-white/10 p-2 text-slate-300 lg:hidden"
                        aria-label={open ? "Fechar menu" : "Abrir menu"}
                    >
                        {open ? <X size={20} /> : <Menu size={20} />}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="border-t border-white/[0.06] bg-[#07090E]/95 px-5 pb-6 pt-3 backdrop-blur-xl lg:hidden"
                >
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`${l.testid}-mobile`}
                            onClick={() => setOpen(false)}
                            className="block border-b border-white/[0.05] py-3.5 text-base font-medium text-slate-300"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href={waLink("general")}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-whatsapp-button-mobile"
                        className="mt-4 flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-bold text-[#052e12]"
                    >
                        <MessageCircle size={17} strokeWidth={2.5} />
                        Falar no WhatsApp
                    </a>
                </div>
            )}
        </header>
    );
};
